<div class="mapfre-icon-information row">
  <div class="col">
    <div class="icon-container align-middle">
      <mapfre-icon 
      [iconClasses]="iconClasses" 
      [iconFamily]="iconFamily">
    </mapfre-icon>
    </div>
    <div class="information-container">
      <div class="title">
        {{ titleType | translate }}
      </div>
      <div class="data">
        {{ data }}
      </div>
    </div>
  </div>
</div>
